import styled from 'styled-components'
import Loader from 'components/Common/Loader'
import DownloadIcon from 'components/Common/Icons/Download'
import { SecondaryIconButtonFlexable32 } from 'components/Common/MasterComponents'

const Button = styled(SecondaryIconButtonFlexable32)`
  width: 32px;
  height: 32px;
`

const DownloadButton = ({ loading, ...props }) => {
  return (
    <Button
      {...props}
      icon={
        loading ? (
          <Loader color='#888998' size='10px' />
        ) : (
          <DownloadIcon size={16} />
        )
      }
    />
  )
}

export default DownloadButton
